import React from 'react';

export const AGENT_AVATARS = [
  { key: 'operator', src: new URL('../../../public/agent-avatars/operator.png', import.meta.url).href, label: 'Operator' },
  { key: 'spark', src: new URL('../../../public/agent-avatars/spark.png', import.meta.url).href, label: 'Spark' },
  { key: 'navigator', src: new URL('../../../public/agent-avatars/navigator.png', import.meta.url).href, label: 'Navigator' },
  { key: 'builder', src: new URL('../../../public/agent-avatars/builder.png', import.meta.url).href, label: 'Builder' },
  { key: 'analyst', src: new URL('../../../public/agent-avatars/analyst.png', import.meta.url).href, label: 'Analyst' },
  { key: 'guardian', src: new URL('../../../public/agent-avatars/guardian.png', import.meta.url).href, label: 'Guardian' },
];

export const AGENT_ACCENTS = {
  cyan: 'from-cyan-400 to-blue-600',
  blue: 'from-blue-400 to-indigo-600',
  violet: 'from-violet-400 to-fuchsia-600',
  emerald: 'from-emerald-400 to-teal-600',
  amber: 'from-amber-300 to-orange-600',
  rose: 'from-rose-400 to-pink-600',
};

const SIZES = {
  '2xs': 'h-6 w-6 rounded-md',
  xs: 'h-7 w-7 rounded-lg',
  sm: 'h-8 w-8 rounded-lg',
  md: 'h-9 w-9 rounded-xl',
  queue: 'h-11 w-11 rounded-xl',
  lg: 'h-14 w-14 rounded-2xl',
  picker: 'h-16 w-16 rounded-2xl',
  xl: 'h-20 w-20 rounded-3xl',
};

// working: the agent is mid-turn; waiting_on_you: it asked the viewer something.
// The ring stays still: pulsing it would fade the picture with it.
const RINGS = {
  working: 'ring-2 ring-cyan-500 ring-offset-2 ring-offset-white',
  waiting_on_you: 'ring-2 ring-amber-400 ring-offset-2 ring-offset-white',
  paused: 'ring-2 ring-slate-300 ring-offset-2 ring-offset-white grayscale',
};

export const STATUS_LABELS = {
  working: 'Working',
  waiting_on_you: 'Waiting on you',
  idle: 'Available',
  paused: 'Paused',
  draft: 'Draft',
  retired: 'Retired',
};

/** Resolve the ring state from an agent row plus its live activity. */
export const agentStatus = (agent, activity = agent?.activity) => {
  if (agent?.status && agent.status !== 'active') return agent.status;
  return activity?.state || 'idle';
};

export function avatarFor(ui = {}, fallbackKey = null) {
  return AGENT_AVATARS.find((item) => item.key === ui?.avatar_key)
    || AGENT_AVATARS.find((item) => item.key === fallbackKey)
    || AGENT_AVATARS[0];
}

export default function AgentAvatar({ ui = {}, size = 'md', status = null, fallbackKey = null, className = '', label = null }) {
  const avatar = avatarFor(ui, fallbackKey);
  const gradient = AGENT_ACCENTS[ui?.accent] || AGENT_ACCENTS.cyan;
  const sizing = SIZES[size] || SIZES.md;
  const ring = RINGS[status] || '';
  return (
    <span
      title={label || avatar.label}
      data-status={status || undefined}
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden bg-gradient-to-br shadow-sm ${gradient} ${sizing} ${ring} ${className}`}
    >
      <img src={avatar.src} alt="" className="h-full w-full object-cover object-top" />
    </span>
  );
}
